import styled from "styled-components";

export const ResourceDetailBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
`;

export const ResourceDetailItemWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  display: inline-grid;
  border-bottom: 1px solid #d2d2d2;
  padding: 10px 0;
  .text {
    margin-top: 4px;
  }
`;
